import PropTypes from 'prop-types';

export default {
  defaultProp: 'en_US',
  propType: PropTypes.oneOf([
    'en_US',
    'de_DE',
    'el_GR',
    'es_ES',
    'fr_FR',
    'fr_CA',
    'it_IT',
    'pl_PL',
    'th_TH',
    'zh_CN',
    'pt_BR',
    'ja_JP',
  ]),
};